"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useMatches_exports = {};
__export(useMatches_exports, {
  getClientMatchesSnapshot: () => getClientMatchesSnapshot,
  setClientMatches: () => setClientMatches,
  subscribeToClientMatches: () => subscribeToClientMatches,
  updateMatchLoaderData: () => updateMatchLoaderData,
  useMatch: () => useMatch,
  useMatches: () => useMatches,
  usePageMatch: () => usePageMatch
});
module.exports = __toCommonJS(useMatches_exports);
var import_react = require("react");
var import_one_server_only = require("./vite/one-server-only");
var clientMatches = [];
var clientMatchesListeners = /* @__PURE__ */ new Set();
function subscribeToClientMatches(callback) {
  clientMatchesListeners.add(callback);
  return function() {
    return clientMatchesListeners.delete(callback);
  };
}
function getClientMatchesSnapshot() {
  return clientMatches;
}
function setClientMatches(matches) {
  clientMatches = matches;
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = clientMatchesListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var listener = _step.value;
      listener();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}
function updateMatchLoaderData(routeId, loaderData) {
  clientMatches = clientMatches.map(function(m) {
    return m.routeId === routeId ? {
      ...m,
      loaderData
    } : m;
  });
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = clientMatchesListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var listener = _step.value;
      listener();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}
function useMatches() {
  var serverContext = (0, import_one_server_only.useServerContext)();
  if (process.env.VITE_ENVIRONMENT === "ssr") {
    var _ref;
    return (_ref = serverContext === null || serverContext === void 0 ? void 0 : serverContext.matches) !== null && _ref !== void 0 ? _ref : [];
  }
  var clientStoreMatches = (0, import_react.useSyncExternalStore)(
    subscribeToClientMatches,
    getClientMatchesSnapshot,
    // server snapshot for hydration - must match what SSR rendered
    function() {
      var _ref2;
      return (_ref2 = serverContext === null || serverContext === void 0 ? void 0 : serverContext.matches) !== null && _ref2 !== void 0 ? _ref2 : [];
    }
  );
  return clientStoreMatches;
}
function useMatch(routeId) {
  var matches = useMatches();
  return matches.find(function(m) {
    return m.routeId === routeId;
  });
}
function usePageMatch() {
  var matches = useMatches();
  return matches[matches.length - 1];
}
//# sourceMappingURL=useMatches.js.map
